import Vue from "vue";

Vue.component("trade-concern-symbol", {
	props: ["viewUrl", "documentSymbol"],
	data() {
		return {
			isExist: false,
			loading: true
		};
	},
	computed: {
		loadingText() {
			return window.labels.loading + "..";
		},
	},
	methods: {
		checkSymbol: function () {
			this.loading = true;
			this.$services.symbols.checkSymbol({
				symbol: this.documentSymbol
			})
				.then((data) => {
					this.loading = false;
					this.isExist = data;
				});
		}
	},
	mounted() {
		this.checkSymbol();
	},
	template: `		
		<div>
			<template v-if="loading">
				<loading :loading-text="loadingText"></loading>
			</template>
			<template v-else>
            	<span v-if="!isExist">{{ documentSymbol }}</span>
              	<a v-if="isExist" v-bind:href="viewUrl">{{ documentSymbol }}</a>
			</template>
		</div>
	`
});